import script from "./NotaFiscalValidacaoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NotaFiscalValidacaoPage.vue?vue&type=script&setup=true&lang=js"

import "./NotaFiscalValidacaoPage.vue?vue&type=style&index=0&id=a9c4a238&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9c4a238"]])

export default __exports__